import { FC } from "react";
import { IconPropsType } from ".";

export const Photo: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7982_46)">
        <path
          d="M13 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15Z"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M3 12L5 10L7 12L11 8L12.5 9.5"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 6C7.75 6.9665 6.9665 7.75 6 7.75C5.0335 7.75 4.25 6.9665 4.25 6C4.25 5.0335 5.0335 4.25 6 4.25C6.9665 4.25 7.75 5.0335 7.75 6Z"
          stroke={props.color}
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_7982_46">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
